import Block from 'components/Block'
import { View } from 'components/View'
import React from 'react'
import { defineMessages } from 'react-intl'
import { useTheme } from 'modules/styles/index.js'
import { SubscriptionPremiumPlusPlan } from 'pages/Premium/FreeVsPremiumFeatures/SubscriptionPlans/PremiumPlus/index.js'
import TextTitleCompressedHeavy from 'components/TextTitleCompressedHeavy.js'
import formatMessageIntlUtil from 'modules/intl/utils/format-message/index.js'
import useIntl from 'modules/component/utils/hooks/useIntl.js'

const messages = defineMessages({
  title: {
    id: 'TrackCaloriesPricing.title',
    defaultMessage: 'What You Get'
  }
})

export function TrackCaloriesPricing () {
  const theme = useTheme()
  const intl = useIntl()

  return (
    <Block
      style={{
        textAlign: 'center'
      }}
    >
      <View mb={4}>
        <TextTitleCompressedHeavy>
          {formatMessageIntlUtil(intl, messages.title)}
        </TextTitleCompressedHeavy>
      </View>

      <View
        centered
        style={{
          maxWidth: theme.maxWidth.desktopCompact
        }}
      >
        <SubscriptionPremiumPlusPlan
          isStandalone
          shouldBoldMainFeatures
        />
      </View>
    </Block>
  )
}
